import { SESSION_STATUS } from "@repo/database/session-status";

export const BLOCKED = new Set<string>([
  SESSION_STATUS.WAITING_HUMAN,
  SESSION_STATUS.AWAITING_APPROVAL,
]);
